import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import loader from "../assets/loader.gif";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { setavatarRoute } from "../utils/APIroutes";
import { Buffer } from "buffer";

const SetAvatar = () => {
  const navigate = useNavigate();
  const [avatars, setAvatars] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedAvatar, setSelectedAvatar] = useState(undefined);

  const toastOptions = {
    position: "bottom-right",
    autoClose: 8000,
    draggable: true,
    theme: "dark",
  };

  useEffect(() => {
    const checkValidUser = async () => {
      const validUser = await localStorage.getItem("chat-app-user");
      if (!validUser) {
        navigate("/login");
      }
    };
    checkValidUser();
  }, [navigate]);

  const setProfilePicture = async () => {
    if (selectedAvatar === undefined) {
      toast.error("Please Select an Avatar", toastOptions);
    } else {
      const user = await JSON.parse(localStorage.getItem("chat-app-user"));
      const { data } = await axios.post(`${setavatarRoute}/${user._id}`, {
        image: avatars[selectedAvatar],
      });
      if (data) {
        user.isAvatarImageSet = true;
        user.avatarImage = data.image;
        localStorage.setItem("chat-app-user", JSON.stringify(user));
        navigate("/");
      } else {
        toast.error("Error in setting Avatar. Please Try again", toastOptions);
      }
    }
  };

  useEffect(() => {
    const getAvatars = async () => {
      try {
        const api = "https://api.multiavatar.com/45";
        const key = "?apikey=q0kwQ1JXB3sFNO";
        const data = [];

        for (let i = 0; i < 5; i++) {
          const num = Math.floor(Math.random() * (999 - 10 + 1) + 10);
          const image = await axios.get(`${api}${num}${key}`);
          const buffer = new Buffer(image.data);
          data.push(buffer.toString("base64"));
        }
        setAvatars(data);
        setIsLoading(false);
      } catch (error) {
        console.log("Some error happened", error);
      }
    };
    getAvatars();
  }, []);

  return (
    <>
      {isLoading ? (
        <Container>
          <img src={loader} alt="loading" className="loader" />
        </Container>
      ) : (
        <Container>
          <div className="title-container">
            <h1>Pick an Avatar as your Profile Picture</h1>
          </div>
          <div className="avatars">
            {avatars.map((avatar, index) => {
              return (
                <div
                  key={index}
                  className={`avatar ${
                    selectedAvatar === index ? "selected" : ""
                  }`}
                >
                  <img
                    src={`data:image/svg+xml;base64,${avatar}`}
                    alt="avatar"
                    onClick={() => setSelectedAvatar(index)}
                  />
                </div>
              );
            })}
          </div>
          <button className="submit-btn" onClick={setProfilePicture}>
            Set as Profile Picture
          </button>
        </Container>
      )}
      <ToastContainer />
    </>
  );
};
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 3em;
  background-color: #131324;
  height: 100vh;
  width: 100vw;
  .loader {
    max-inline-size: 100%;
  }
  .title-container {
    h1 {
      color: #fff;
    }
  }
  .avatars {
    display: flex;
    gap: 2rem;
    .avatar {
      border: 0.4rem solid transparent;
      padding: 0.4rem;
      border-radius: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: 0.5s ease-in-out;
      img {
        height: 6rem;
      }
    }
    .selected {
      border: 0.4rem solid #4e0eff;
    }
  }
  .submit-btn {
    background-color: #e71ca8;
    color: #fff;
    padding: 1rem 2rem;
    border: none;
    font-weight: bold;
    cursor: pointer;
    border-radius: 0.4rem;
    font-size: 1rem;
    text-transform: uppercase;
    transition: 0.5s;
    &:hover {
      background-color: #4e0eff;
    }
  }

  @media screen and (max-width: 810px) {
    gap: 2em;
    .loader {
      max-inline-size: 100%;
    }
    .title-container {
      h1 {
        font-size: 1.6em;
      }
    }
    .avatars {
      gap: .4rem;
      .avatar {
        padding: 0.4rem;
        border-radius: 5rem;
        img {
          height: 5rem;
        }
      }
      .selected {
        border: 0.4rem solid #4e0eff;
      }
    }
    .submit-btn {
      padding: 1rem 2rem;
      font-size: .8rem;
    }
  }

  @media screen and (max-width: 550px) {
    gap: 2em;
    .title-container {
      h1 {
        font-size: 1.3em;
        text-align: center;
      }
    }
    .avatars {
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 4px;
      .avatar {
        padding: 0.4rem;
        img {
          height: 3rem;
        }
      }
      .selected {
        border: 0.1rem solid #4e0eff;
      }
    }
    .submit-btn {
      padding: 8px 12px;
      font-size: .8rem;
    }
  }
`;

export default SetAvatar;
